// extracted by mini-css-extract-plugin
module.exports = {"grey":"#4B5766","blue":"#005CFF","moving":"Nav_moving__xGx6u","active":"Nav_active__1PD6c"};